export default [
  {
    path: "login",
    name: "auth-login",
    component: () => import("@/modules/auth/views/AuthLogin.vue"),
  },
  {
    path: "forgot-password",
    name: "auth-forgot-password",
    component: () => import("@/modules/auth/views/AuthForgotPassword.vue"),
  },
  {
    path: "password-reset/:token?",
    name: "auth-password-reset",
    component: () => import("@/modules/auth/views/AuthResetPassword.vue"),
  },
];
